<template>
  <div>
    <div
      aria-live="assertive"
      class="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start z-50"
    >
      <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
        <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
        <transition
          enter-active-class="animate__animated animate__fadeInRight animate__fast"
          leave-active-class="animate__animated animate__fadeOutRight animate__fast"
        >

          <div
            v-if="showConfirm"
            :class="status == 'success' ? 'bg-green-50 border-l-4 border-green-500 text-green-500':'bg-red-50 border-l-4 border-red-500 text-red-500'"
            class="max-w-sm w-full shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden"
          >
            <div class="px-4 py-7">
              <div class="flex items-start">
                <svg
                  v-if="status == 'success'"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <svg
                  v-if="status == 'error'"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <div class="ml-3 w-0 flex-1 pt-0.5">
                  <p
                    class="text-sm font-medium "
                    :class="status == 'success' ? 'text-green-900':'text-red-900'"
                  >
                    {{msg}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </transition>

      </div>
    </div>
    <div class="flex aic jcb w-full">
      <SideNav :showMenu="sideMenu" />
      <Products />
    </div>
  </div>
</template>

<script>
import SideNav from "@/components/SideNav.vue";
import Products from "@/components/Products.vue";
export default {
  components: {
    SideNav,
    Products,
  },
  data() {
    return {
      showConfirm: false,
      msg: "",
      status: "",
    };
  },
  computed: {
    sideMenu(){
      if(process.env.VUE_APP_SIDEMENU == 'side_menu') {
        return true
      }
      else {
        return false
      }
    },
    restaurantId() {
      return process.env.VUE_APP_RESTAURANT_ID;
    },
    tableName() {
      return this.$route.query.tableName;
    },
    tableId() {
      return this.$route.query.tableId;
    },
  },
  methods: {
    addNewTime() {
      Date.prototype.addHours = function (h) {
        this.setTime(this.getTime() + h * 60 * 60 * 1000);
        return this;
      };
      var dateNow = new Date().addHours(1);
      let date = `${dateNow.getFullYear()}-${
        dateNow.getUTCMonth() + 1
      }-${dateNow.getUTCDate()}`;
      let time = `${dateNow.getHours().toString().padStart(2, "0")}:${dateNow
        .getMinutes()
        .toString()
        .padStart(2, "0")}`;
      return this.$store
        .dispatch("order/addDeliveryTimeToBasket", {
          time: time,
          date: date,
          restaurantId: this.restaurantId,
        })
        .then(() => {
          this.$store.commit("product/setDeliveryTime", `${date} ${time}`);
        });
    },
    createBasket() {
      const table = this.tableId
        ? { tableId: this.tableId, qrcode: 1 }
        : this.tableName
        ? { tableName: this.tableName, qrcode: 1 }
        : null;
      const basket = JSON.parse(localStorage.getItem("basket")) || [];
      const basketId = basket.find(
        (basket) => basket.restaurantId == this.restaurantId
      );
      if (!basketId) {
        return this.$store
          .dispatch("order/createBasket", {
            restaurantId: this.restaurantId,
          })
          .then(() => {
            if (table) {
              return this.$store
                .dispatch("order/setTable", {
                  restaurantId: this.restaurantId,
                  ...table,
                })
                .then((res) => {
                  let query = Object.assign({}, this.$route.query);
                  if (query.tableId) delete query.tableId;
                  else if (query.tableName) delete query.tableName;
                  this.$router.replace({ query });
                  if (res.type == "error") {
                    this.status = "error";
                    this.msg = res.msg;
                    this.showConfirm = true;
                    setTimeout(() => {
                      this.showConfirm = false;
                    }, 3000);
                  }
                });
            }
          });
      } else {
        if (table) {
          return this.$store
            .dispatch("order/setTable", {
              restaurantId: this.restaurantId,
              ...table,
            })
            .then((res) => {
              if (res.type == "error") {
                this.status = "error";
                this.msg = res.msg;
                this.showConfirm = true;
                setTimeout(() => {
                  this.showConfirm = false;
                }, 3000);
              }
              this.addNewTime().then(() => {
                let query = Object.assign({}, this.$route.query);
                if (query.tableId) delete query.tableId;
                else if (query.tableName) delete query.tableName;
                this.$router.replace({ query });
              });
            });
        }
      }
    },
  },
  mounted() {  

    if (!localStorage.getItem("publicToken")) {
      this.$store.dispatch("auth/auth").then(() => {
        this.createBasket();
      });
    } else {
      this.createBasket();
    }
  },
};
</script>

<style></style>
